import React, { createContext, useContext, useState, ReactNode } from 'react';

export type NotificationSeverity = 'error' | 'warning' | 'info' | 'success';

interface Notification {
  message: string;
  severity: NotificationSeverity;
}

interface NotificationContextType {
  notification: Notification | null;
  showNotification: (message: string, severity: NotificationSeverity) => void;
  hideNotification: () => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const NotificationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [notification, setNotification] = useState<Notification | null>(null);

  const showNotification = (message: string, severity: NotificationSeverity) => {
    setNotification({ message, severity });
  };

  const hideNotification = () => {
    setNotification(null);
  };

  return (
    <NotificationContext.Provider value={{ notification, showNotification, hideNotification }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotification must be used within a NotificationProvider');
  }
  return context;
};